import React, { useLayoutEffect, useReducer } from 'react';
import './App.css';
import axios from 'axios';


import SearchIcon from '@material-ui/icons/Search';

import Clear from '@material-ui/icons/Clear';
import Button from '@material-ui/core/Button';

import PropTypes from "prop-types";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Fab from '@material-ui/core/Fab';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Zoom from '@material-ui/core/Zoom';

import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { TextField } from '@material-ui/core';

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Fade from '@material-ui/core/Fade';

import Typography from '@material-ui/core/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { faIdBadge } from '@fortawesome/free-regular-svg-icons';
import Grid from '@material-ui/core/Grid';


import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import CircularProgress from '@material-ui/core/CircularProgress';
import sanitizeHtml from 'sanitize-html';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 900,
        backgroundColor: theme.palette.background.paper,

    },
    accordion: {
        marginTop: 2,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    dropdown1: {
        [theme.breakpoints.down('sm')]: {
            width: 220,
        },
        [theme.breakpoints.up('md')]: {
            width: 300,
        },
        [theme.breakpoints.up('lg')]: {
            width: 400,
        },
        [theme.breakpoints.up('lg')]: {
            width: 420,
        },
    },
    dropdown2: {
        width: 290,
    },
    classContainer: {
        padding: 0,
    },
    pipeSeperator: {
        color: '#d8d8d8',
        marginLeft: 10,
        marginRight: 10,
        borderRight: '1px solid #d8d8d8'
    },
    greyedOut: {
        color: "#777777",
    },
    detailsPanel: {
        display: 'flex',
        flexDirection: 'column',
    },
    offCampus: {
        color: "#EB0000;",
        maxHeight: 18,
        position: 'relative',
        marginLeft: -3,
        top: 3,

    },
    info: {
        color: "#777777;",
        maxHeight: 18,
        position: 'relative',
        marginLeft: -3,
        top: 3,

    },
    formControl: {
        margin: 5,

    },
    button: {
        margin: theme.spacing(2),
    },

    classArea: {
        marginTop: 20,
    },
    heading: {
        fontSize: 18,
    },
    menuItem: {
        whiteSpace: "unset",
        wordBreak: "break-all",
    },
    progress: {
        maxWidth: 800,
    },

    scrollButton: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        backgroundColor: "#A7C9FE",
        color: "#000000",
    },

    paperFilter: {
        maxWidth: 180,
        position: 'fixed',
        right: 30,
        padding: 10,
    },
    changeAvatar:{
        color: '#852F78',
        marginRight: '16px',
        textAlign: 'right',
        fontSize: '20px',
        float: "right",
        position: "relative",
        transform: "translateY(55%)",
      },
      changeAvatarNoSpace:{
        color: '#852F78',
        fontSize: '20px',
       
      },

}));

function ScrollTop(props) {
    const { children } = props;
    const classes = useStyles();
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 400
    });

    const handleClickScroll = event => {
        const anchor = (event.target.ownerDocument || document).querySelector(
            "#back-to-top-anchor"
        );

        if (anchor) {
            anchor.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    return (
        <Zoom in={trigger}>
            <div onClick={handleClickScroll} role="presentation" className={classes.scrollButton}>
                {children}
            </div>
        </Zoom>
    );
}

ScrollTop.propTypes = {
    children: PropTypes.element.isRequired
};

//#region StateMachine

const stateMachine = (state, action) => {

    switch (action.type) {
        case 'initFaculty':
            return { ...state, data: action.payload }

        case 'initTitles':
            return { ...state, titles: action.payload }

        case 'initNav':
            return { ...state, titles: action.payload }


        case 'changeTitles':
            return { ...state, titlesOpen: action.open, titlesFilter: action.titlesFilter, displayedFaculty: action.displayedFaculty }

        case 'openTitles':
            return { ...state, titlesOpen: action.open }

        case 'titlesError':
            return { ...state, titlesOpen: action.open, titlesError: true }

        case 'search':
            return { ...state, displayedFaculty: action.payload }

        case 'clear':
            return { ...state, displayedFaculty: action.payload, departmentsFilter: '', titlesFilter: '' }

        default:
            return { ...state }
    }

}

//#endregion 


function FacultyDirectory() {

    const [state, dispatch] = useReducer(stateMachine, {
        data: [],
        titles: [],
        departments: [],
        titlesFilter: '',
        departmentsFilter: '',
        titlesOpen: false,
        departmentsOpen: false,
        titlesError: false,
        departmentsError: false,
        displayedFaculty: [],
        searchedFaculty: [],
        searchText: '',
        allNavMenu: [],
        navMenu:[],
    }
    )

    const classes = useStyles();

    let searchT = React.useRef('');

    let subjectList = [];
    const search = window.location.search;
    const params = new URLSearchParams(search);
    var subject = params.get('subject');

    //#region Effects

    useLayoutEffect(() => {


        const fetchFaculty = async () => {

            try {

                const result = await axios({

                    method: 'get',

                    headers: {
                        'Content-Type': 'application/json',

                        'X-DreamFactory-Api-Key': '0aea284ad986d66628648574825c8da57e7326a7514a5f87b713bab87eb03762'
                    },

                    crossDomain: true,

                    url: 'https://dfprd.heartland.edu/api/v2/k2_smartboxdata/_table/Faculty_Business_Card?order=Last_Name%20ASC'

                });

                dispatch({ type: 'initFaculty', payload: result.data.resource });

            } catch (error) {
                console.log(error);
                const result = await axios.get('faculty.json');
                dispatch({ type: 'initFaculty', payload: result.data.resource });
            }


        };


        const fetchTitles = async () => {
            try {

                const result = await axios({

                    method: 'get',

                    headers: {
                        'Content-Type': 'application/json',

                        'X-DreamFactory-Api-Key': 'c5ce55a2b4dca4136049dd1d0fd83fde785fb70683084ccd22e5f0f024f2c222'
                    },

                    crossDomain: true,

                    url: 'https://dfprd.heartland.edu/api/v2/k2_smartboxdata/_table/FacBusCard_Subject_TEST_SMO_1?order=Subject_Name%20ASC'

                });
                dispatch({ type: 'initTitles', payload: result.data.resource });

            } catch (error) {
                console.log(error);
                const result = await axios.get('titles.json');
                dispatch({ type: 'initTitles', payload: result.data.resource });
            }
        };

        
        const fetchNav = async () => {
            try{
             const result = await axios.get('navigation.json');   
        
             dispatch ( {type: 'initNav', payload:result.data.resource});          
           
           } catch (error){
             console.log(error); 
            }
           };   


        fetchTitles();
        fetchFaculty();
        fetchNav();

    }, []);

    //#endregion

    //#region Handlers 


    const handleTitlesChange = event => {
        stateLogic("changeTitles", !state.titlesOpen, event.target.value);

    }

    const handleTitlesSearched = (event) => {
        stateLogicSearched("changeTitles", !state.titlesOpen, event.target.value);
    }

    const handleTitlesClose = () => {
        dispatch({ type: "openTitles", open: false });
    }

    const handleTitlesOpen = () => {

        dispatch({ type: "openTitles", open: true });
    }


    const handleClear = () => {
        if (searchT.current.value) {
            searchT.current.value = "";
        }


        dispatch({ type: "clear", payload: state.data });
    }

    const searchFilter = (searchText, array) => {
        searchText = searchText.toLowerCase();
        let searchedFaculty = array.filter(item => (item.First_Name.toLowerCase().includes(searchText)) || (item.ABB1.toLowerCase().includes(searchText)) || (item.ABB2 != null && (item.ABB2.toLowerCase().includes(searchText))) || (item.ABB3 != null && (item.ABB3.toLowerCase().includes(searchText))) || (item.ABB4 != null && (item.ABB4.toLowerCase().includes(searchText))) || (item.ABB5 != null && (item.ABB5.toLowerCase().includes(searchText))) || (((item.First_Name.toLowerCase()) + ' ' + (item.Last_Name.toLowerCase())).includes(searchText)) || (item.Last_Name.toLowerCase().includes(searchText)) || (item.Subject_Long.toLowerCase().includes(searchText)) || (item.SUBJECT_LONG2 != null && (item.SUBJECT_LONG2.toLowerCase().includes(searchText))) || (item.SUBJECT_LONG3 != null && (item.SUBJECT_LONG3.toLowerCase().includes(searchText))) || (item.SUBJECT_LONG4 != null && (item.SUBJECT_LONG4.toLowerCase().includes(searchText))) || (item.SUBJECT_LONG5 != null && (item.SUBJECT_LONG5.toLowerCase().includes(searchText))));
        searchedFaculty.sort((a, b) => {
            let valA = '';
            let valB = ';'
            if (a.Last_Name.toLowerCase().includes(searchText)) {
                valA = 0;
            } else {
                valA = 1;
            }

            if (b.Last_Name.toLowerCase().includes(searchText)) {
                valB = 0;
            } else {
                valB = 1;
            }
            return valA - valB;
        }

        );

        return searchedFaculty;
    }

    const handleSearch = event => {
        stateLogicSearched("search", null, event.target.value.toLowerCase());

    }

    const stateLogic = (dispatchType, controlState, filter) => {

        switch (dispatchType) {

            case 'changeTitles':

                //All blank 
                if ((filter === '' || filter === 'ALL')) {
                    return dispatch({ type: dispatchType, open: controlState, displayedFaculty: state.data.filter, titlesFilter: filter });
                }

                //Titles Alone 
                if ((filter !== '' && filter !== 'ALL')) {
                    return dispatch({ type: dispatchType, open: controlState, displayedFaculty: state.data.filter(item => (item.ABB1 === filter || item.ABB2 === filter || item.ABB3 === filter || item.ABB4 === filter || item.ABB5 === filter)), titlesFilter: filter });
                }


                break;



            default:
                return dispatch({ type: "clear", payload: state.data });
        }


    }

    const stateLogicSearched = (dispatchType, controlState, filter) => {


        switch (dispatchType) {

            case 'changeTitles':

                //All blank 
                if ((filter === '' || filter === 'ALL')) {
                    let faculty = state.data.filter(item => (item.End_Date === "2099-12-31" || item.End_Date === "12/31/2099"));
                    return dispatch({ type: dispatchType, open: controlState, displayedFaculty: searchFilter(searchT.current.value, faculty), titlesFilter: filter });
                }

                //Title Alone 
                if ((filter !== '' && filter !== 'ALL')) {
                    let faculty = state.data.filter(item => (item.End_Date === "2099-12-31" || item.End_Date === "12/31/2099"|| item.ABB1 === filter || item.ABB2 === filter || item.ABB3 === filter || item.ABB4 === filter || item.ABB5 === filter));
                    return dispatch({ type: dispatchType, open: controlState, displayedFaculty: searchFilter(searchT.current.value, faculty), titlesFilter: filter });
                }



                break;


            case 'search':

                //All blank 
                if ((state.titlesFilter === '' || state.titlesFilter === 'ALL')) {
                    let faculty = state.data.filter(item => (item.End_Date === "2099-12-31" || item.End_Date === "12/31/2099"));
                    return dispatch({ type: dispatchType, payload: searchFilter(searchT.current.value, faculty) });
                }

                //Title only
                if ((state.titlesFilter !== '' && state.titlesFilter !== 'ALL')) {
                    let faculty = state.data.filter(item => item.TITLE === state.titlesFilter && (item.End_Date === "2099-12-31" || item.End_Date === "12/31/2099")) ;
                    return dispatch({ type: dispatchType, payload: searchFilter(searchT.current.value, faculty) });
                }

                break;
            default:
                return dispatch({ type: "clear", payload: state.data });
        }
    }

    //#endregion

    return (

        <div className={classes.classContainer}>

            <div>
                <h1>Faculty Directory</h1>

                <FormControl className={classes.formControl}>
                    <TextField InputLabelProps={{ shrink: (searchT.current.value !== '' && searchT.current.value !== undefined) }} id="search" label="Search" inputRef={searchT} onChange={handleSearch} />
                    <div style={{ position: 'absolute', top: '22px', right: '1px' }}> <SearchIcon aria-hidden='true' /> </div>
                </FormControl>

              
           

                <FormControl error={state.titlesError} className={classes.formControl}>
                    <InputLabel id="subject-label" htmlFor={'input-id'}>Filter by Subject</InputLabel>
                    <Select
                        inputProps={{id: 'input-id'}}
                        className={classes.dropdown1}
                        autoWidth={true}
                        labelId="subject-label"
                        id="subject"
                        open={state.titlesOpen}
                        onClose={handleTitlesClose}
                        onOpen={handleTitlesOpen}
                        value={state.titlesFilter}
                        onChange={(searchT.current.value === '') ? handleTitlesChange : handleTitlesSearched}

                    >
                        <MenuItem key="ALL" value="ALL">
                            <em>All</em>
                        </MenuItem>
                        {
                            state.titles.map((item, index) => (
                                <MenuItem key={index} value={item.SUBJECT} >{item.Subject_Name}</MenuItem>
                            ))
                        }

                    </Select>
                </FormControl>


                <FormControl className={classes.formControl}>
                    <Button className={classes.button}
                        variant="outlined"
                        color="primary"
                        onClick={handleClear}
                        startIcon={<Clear />}
                    >
                        Clear
                    </Button></FormControl>
            </div>

            <div className = "editTip">
        <Typography ><FontAwesomeIcon icon={faIdBadge} className={classes.changeAvatarNoSpace}/> icon indicates full-time faculty </Typography>
        </div>

            <div id="back-to-top-anchor"></div>

            <div>
                <ul>
                    {(state.data.length === 0) && <div className="progress"><CircularProgress variant="indeterminate" /> </div>}

                    <div className="card-section">
                        <Grid container>
                            <ul>
                                {(state.titlesFilter === '' && searchT.current.value === '') &&
                                    (state.data.filter(item => (item.End_Date === "2099-12-31" || item.End_Date === "12/31/2099"))).map((item, index) => (
                                        <li key={item.index}>
                                        

                                                <Fade in={true} style={{ transitionDelay: "170ms" }}>

                                                    <Card className="card">
                                                    {(item.Status === "Full-Time") &&
                                                            <FontAwesomeIcon icon={faIdBadge} className={classes.changeAvatar} />
                                                        }
                                                        <CardHeader title={item.First_Name + " " + item.Last_Name} />
                                                        <CardContent>
                                                            <Typography variant="h2">
                                                                {item.Title}
                                                            </Typography>

                                                            <Typography className={classes.root}>
                                                                Subject(s):

                                                            </Typography>

                                                            <Typography className={classes.root}>

                                                                <a href={item.Subject_URL}> {item.Subject_Long}</a>

                                                                {(item.SUBJECT_LONG2 != null) &&
                                                                    <a href={item.SUBJECT_URL2}>, {item.SUBJECT_LONG2}</a>
                                                                }

                                                                {(item.SUBJECT_LONG3 != null) &&
                                                                    <a href={item.SUBJECT_URL3}>, {item.SUBJECT_LONG3}</a>
                                                                }

                                                                {(item.SUBJECT_LONG4 != null) &&
                                                                    <a href={item.SUBJECT_URL4}>, {item.SUBJECT_LONG4}</a>
                                                                }

                                                                {(item.SUBJECT_LONG5 != null) &&
                                                                    <a href={item.SUBJECT_URL5}>, {item.SUBJECT_LONG5}</a>
                                                                }
                                                            </Typography>

                                                        </CardContent>

                                                        <List component="nav" aria-label="main faculty contact information">
                                                            <div className="listSize">

                                                                <ListItem>
                                                                    <ListItemIcon>
                                                                        <FontAwesomeIcon icon={faBuilding} />
                                                                    </ListItemIcon>
                                                                    <div className="hidden">"Office Location:"</div>
                                                                    <ListItemText primary={sanitizeHtml(item.Office_Location)}/>
                                                                </ListItem>

                                                                <ListItem button component="a" href={"mailto:" + sanitizeHtml(item.Email)}>
                                                                    <ListItemIcon>
                                                                        <FontAwesomeIcon icon={faEnvelope} />
                                                                    </ListItemIcon>
                                                                    <div className="hidden">"Email:"</div>
                                                                    <ListItemText inset primary={sanitizeHtml(item.Email)}/>
                                                                </ListItem>

                                                                {item.Phone != null &&
                                                                    <ListItem button component="a" href={"tel:" + sanitizeHtml(item.Phone)}>
                                                                        <ListItemIcon>
                                                                            <FontAwesomeIcon icon={faPhone} />
                                                                        </ListItemIcon>
                                                                        <div className="hidden">"Phone:"</div>
                                                                        <ListItemText inset primary={sanitizeHtml(item.Phone)} />
                                                                    </ListItem>}

                                                            </div>

                                                        </List>
                                                    </Card>
                                                </Fade>
                                    
                                        </li>

                                    ))
                                }
                                {(state.titleFilter !== '' || searchT.current.value !== '') && (state.displayedFaculty.filter(item => (item.End_Date === "2099-12-31" || item.End_Date === "12/31/2099"))).map((item, index) => (
                                    <li key={item.index}>
                                   
                                   

                                            <Fade in={true} style={{ transitionDelay: "170ms" }}>

                                                <Card className="card">
                                                    {(item.Status === "Full-Time") &&
                                                        <FontAwesomeIcon icon={faIdBadge} className={classes.changeAvatar} />
                                                    }

                                                    <CardHeader title={item.First_Name + " " + item.Last_Name} />
                                                    <CardContent>
                                                        <Typography variant="h6">
                                                            {item.Title}
                                                        </Typography>

                                                        <Typography className={classes.root}>
                                                            Subject(s):

                                                        </Typography>

                                                        <Typography className={classes.root}>

                                                            <a href={item.Subject_URL}> {item.Subject_Long}</a>

                                                            {(item.SUBJECT_LONG2 != null) &&
                                                                <a href={item.SUBJECT_URL2}>, {item.SUBJECT_LONG2}</a>
                                                            }

                                                            {(item.SUBJECT_LONG3 != null) &&
                                                                <a href={item.SUBJECT_URL3}>, {item.SUBJECT_LONG3}</a>
                                                            }

                                                            {(item.SUBJECT_LONG4 != null) &&
                                                                <a href={item.SUBJECT_URL4}>, {item.SUBJECT_LONG4}</a>
                                                            }

                                                            {(item.SUBJECT_LONG5 != null) &&
                                                                <a href={item.SUBJECT_URL5}>, {item.SUBJECT_LONG5}</a>
                                                            }
                                                        </Typography>

                                                    </CardContent>

                                                    <List component="nav" aria-label="main faculty contact information">
                                                        <div className="listSize">

                                                            <ListItem>
                                                                <ListItemIcon>
                                                                    <FontAwesomeIcon icon={faBuilding} />
                                                                </ListItemIcon>
                                                                <div className="hidden">"Office Location:"</div>
                                                                <ListItemText primary={sanitizeHtml(item.Office_Location)} id="officeStyle" />
                                                            </ListItem>

                                                            <ListItem button component="a" href={"mailto:" + sanitizeHtml(item.Email)}>
                                                                <ListItemIcon>
                                                                    <FontAwesomeIcon icon={faEnvelope} />
                                                                </ListItemIcon>
                                                                <div className="hidden">"Email:"</div>
                                                                <ListItemText inset primary={sanitizeHtml(item.Email)} id="emailStyle" />
                                                            </ListItem>

                                                            {item.Phone != null &&
                                                                <ListItem button component="a" href={"tel:" + sanitizeHtml(item.Phone)}>
                                                                    <ListItemIcon>
                                                                        <FontAwesomeIcon icon={faPhone} />
                                                                    </ListItemIcon>
                                                                    <div className="hidden">"Phone:"</div>
                                                                    <ListItemText inset primary={sanitizeHtml(item.Phone)} />
                                                                </ListItem>}

                                                        </div>

                                                    </List>
                                                </Card>
                                            </Fade>
                     
                                    </li>

                                ))}
                            </ul>
                        </Grid>
                    </div>

                </ul>
                <div>
                    <ScrollTop>
                        <Fab size="large" aria-label="scroll back to top">
                            <KeyboardArrowUpIcon />
                        </Fab>
                    </ScrollTop>
                </div>

            </div>

        </div>

    );
}

export default FacultyDirectory;
